import React, { ReactChild } from 'react';

const IcCreditCard = ({ fill }): ReactChild => {
  const mainFill = fill || '#000';

  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23 3.75H2V9V20.25H23V9V3.75ZM21.5 8.25V5.25H3.5V8.25H21.5ZM3.5 9.75H21.5V18.75H3.5V9.75Z"
        fill={mainFill}
        fillOpacity="0.75"
      />
    </svg>
  );
};

export default IcCreditCard;
